import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface IDisclaimerProps {
  theme: ITheme // TODO:VJ : default import setup to be done
}

export const Disclaimer = styled('section')<IDisclaimerProps>`
  label: Disclaimer;
  font-size: 14px;
  color: ${(props) => props.theme.colors.textDarkblack};
  h2 {
    font-size: 18px;
    font-weight: 900;
  }
  p {
    span {
      font-weight: 900;
    }
  }
  a {
    font-weight: 900;
    text-decoration: underline;
    color: ${(props) => props.theme.colors.secondary};
    display: initial !important;
  }
`
